import { jsx as _jsx } from "react/jsx-runtime";
import { GraficoBarra } from "@monorepo-web/components-library";
import { BaseGraficoPDF, GraficoBarraPDF } from "@monorepo-web/pdf-generator";
import { FormatTypes } from "@monorepo-web/utils";
export default function GraficoGanhoFinanceiroPDF(props) {
    const { docObj, data, moneyPrefix, config, theme } = props;
    return (_jsx(BaseGraficoPDF, Object.assign({}, props, { idGraph: "GanhoFinanceiro", GraphComponent: GraficoBarra, GraphComponentsProps: {
            data,
            decimals: 2,
            height: 300,
            colors: theme.barChartColor,
            tipo: FormatTypes.percentage,
            isPercentToggle: false,
            showAnimation: true,
            moneyPrefix: moneyPrefix !== null && moneyPrefix !== void 0 ? moneyPrefix : null
        }, containerWidth: 1200, containerHeight: 300, createPDFGraph: (svg) => new GraficoBarraPDF(config, svg, 'Ganho Financeiro (últimos 12m)', null, docObj.marginBottomTable) })));
}
